import { applyMiddleware, combineReducers, legacy_createStore } from "redux";
import { thunk } from 'redux-thunk';
import { reducer as ApplicationReducer } from "./ApplicationReducer/reducer";
import { reducer as AuthReducer } from "./AuthReducer/reducer";
import { reducer as TrancheReducer } from "./TrancheReducer/reducer";
import { reducer as TVRReducer } from "./TVRReducer/reducer";
import { reducer as ReportsReducer } from "./ReportsReducer/reducer";
import { reducer as LeadsReducer } from "./LeadsReducer/reducer";
import { reducer as TasksReducer } from "./TaskReducer/reducer";
import { reducer as UserReducer } from "./UserReducer/reducer";
import { reducer as BranchReducer } from "./BranchReducer/reducer";
import { reducer as AnalyticsReducer } from "./AnalyticsReducer/reducer";
import { reducer as TeamOverviewReducer } from "./TeamOverviewReducer/reducer";

const rootReducer = combineReducers({
    ApplicationReducer,
    AuthReducer,
    TrancheReducer,
    TVRReducer,
    ReportsReducer,
    LeadsReducer,
    TasksReducer,
    UserReducer,
    BranchReducer,
    AnalyticsReducer,
    TeamOverviewReducer
});

export const store = legacy_createStore(rootReducer, applyMiddleware(thunk));